import React, { memo, useState } from 'react';
import CopilotRefTagChip from '../CopilotRefTagChip';
import type { ICopilotRefTagChipProps } from '../CopilotRefTagChip';
import FileItem from '../../../ImgUploadRenderList/FileItem';
import removeIcon from '@/pages/aigc/assets/svg/remove.svg';

/**
 * 输入区外部引用卡片 props。
 * 在 CopilotRefTagChip 基础上增加 form，用于按类型选择卡片实现。
 */
export interface IExternalRefCardProps extends ICopilotRefTagChipProps {
  /** Copilot 外部来源 form，对应历史引用 frontend_metadata.type */
  form?: string;
}

/**
 * AI Gallery 报告引用卡片：文件样式，可删除。
 * @param props - 卡片属性
 * @param props.text - 报告标题（pageName / prefixTag）
 * @param props.onDismiss - 删除时调用，清掉外部引用（含 quoted_content / files）
 */
const AIGalleryReportRefCard: React.FC<IExternalRefCardProps> = ({ text, onDismiss }) => {
  /** 悬停时展示删除按钮 */
  const [hovered, setHovered] = useState(false);
  if (!text) {
    return null;
  }
  return (
    <div className="dba-qa-input-img-wrapper">
      <div className="dba-file-list">
        <div
          className="dba-file-item-box"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <FileItem
            file={{
              id: 'external-aigallery-report',
              name: text,
              status: 'success',
              type: 'html',
              metadata: { name: text },
            }}
          />
          {hovered && (
            <img
              className="dba-file-item-remove"
              src={removeIcon}
              onClick={(e) => {
                e.stopPropagation();
                onDismiss?.();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

/**
 * form → 输入区引用卡片。新增类型在此登记即可，未登记的走 CopilotRefTagChip。
 */
const EXTERNAL_REF_CARD_MAP: Record<string, React.FC<IExternalRefCardProps>> = {
  aigallery_report: AIGalleryReportRefCard,
};

/**
 * 按 form 渲染输入区外部引用卡片。
 * @param props - 卡片属性（含 form / text 等）
 */
const ExternalRefCard: React.FC<IExternalRefCardProps> = (props) => {
  const Card = EXTERNAL_REF_CARD_MAP[props.form ?? ''] ?? CopilotRefTagChip;
  return <Card {...props} />;
};

export default memo(ExternalRefCard);
